import React, { useState } from 'react';
import ServicesFormModal from './ServicesFormModal';

const EditCityButton = ({ columnData, onUpdateService }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const showModal = () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const onSubmit = async (data) => {
    const payloadObj = {
      id: columnData.id,
      payload: { home_service: data },
    };
    await onUpdateService(payloadObj);
    hideModal();
  };
  return (
    <>
      <ServicesFormModal
        data={columnData}
        onSubmit={onSubmit}
        onCancel={hideModal}
        visible={modalVisible}
        title="Edit Service"
        submitText="Update Service"
      />

      <div onClick={showModal}> Edit Service </div>
    </>
  );
};
export default EditCityButton;
